import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild, ElementRef, TemplateRef, SimpleChanges} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map} from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';

// sycfusion dialog 
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { JobSubject } from './../../../shared/models/jobSubject.model';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
// import { ToolbarService } from '@syncfusion/ej2-angular-grids';
import { ToolbarService, HtmlEditorService, CountService, ImageService, LinkService, PasteCleanupService } from '@syncfusion/ej2-angular-richtexteditor';
import { DocumentEditorComponent } from '@syncfusion/ej2-angular-documenteditor';


@Component({
  selector: 'app-job-create-form-subject-additions',
  templateUrl: './job-create-form-subject-additions.component.html',
  styleUrls: ['./job-create-form-subject-additions.component.scss']
})
export class JobCreateFormSubjectAdditionsComponent implements OnInit, OnChanges {

  @Input() job_id: number;
  schema: any;
  form: FormGroup;
  job: any;
  system_log_type_data_sector: any;
  previewHTML: string = '';
showPreview: boolean = false;

  constructor(
     private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private fb: FormBuilder
  ) { 

// this.getSystemLogTypeDataSector(24) // hard coded into the data sector system.
          // this.getSystemLogTypeDataSector(24) // hard coded into the data sector system.

  }


  ngOnInit() {
    // this.loadSchemaAndData();
              // this.getJob(this.job_id);

              // combined function to ensure the schema is loaded before the form.
this.getSystemLogTypeDataSectorAndThenLoadJob(this.job_id)

  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['job_id'] && this.job_id) {
//  this.getJob(this.job_id);
    }
  }


  loadSchemaAndData() {
    // this.jobService.getJob(this.jobId).subscribe(job => {
    //   this.schema = job.schema; // from DB
    //   const savedData = job.form_data || {};
    //   this.form = this.buildForm(this.schema, savedData);
    // });
  }



buildForm(schema: any[], data: any = {}): FormGroup {
  const group: any = {};

  schema.forEach(field => {
    if (!field || !field.key) return;

    const fieldValue = data[field.key];

    if (field.type === 'group') {
      if (field.repeatable) {
        const items = Array.isArray(fieldValue) ? fieldValue : [];

        group[field.key] = this.fb.array(
          items.map((item: any) => this.buildForm(field.fields, item))
        );
      } else {
        const nestedData = typeof fieldValue === 'object' ? fieldValue : {};
        group[field.key] = this.buildForm(field.fields, nestedData);
      }
    } else {
      group[field.key] = new FormControl(
        fieldValue || '',
        field.required ? Validators.required : null
      );
    }
  });

  return this.fb.group(group);
}

getFormArray(fieldKey: string, parentGroup?: AbstractControl): FormArray {
  const group = parentGroup ?? this.form;
  return group.get(fieldKey) as FormArray;
}

addRepeatingGroup(fieldKey: string, fieldsSchema: any[], parentGroup: FormGroup = this.form) {
  const formArray = parentGroup.get(fieldKey) as FormArray;

  if (!formArray || !(formArray instanceof FormArray)) {
    console.error(`FormArray '${fieldKey}' not found in`, parentGroup);
    return;
  }

  formArray.push(this.buildForm(fieldsSchema));
}






  // submitForm() {
  //   const formData = this.form.value;
  //   const htmlBlock = this.generateHTML(formData);

  //   // this.jobService.getJob(this.jobId).subscribe(job => {
  //   //   const updatedJob = {
  //   //     ...job,
  //   //     form_data: formData,
  //   //     special_instructions: (job.special_instructions || '') +
  //   //       `<div class="form-entry" data-marker="form-entry-${new Date().toISOString()}">
  //   //          ${htmlBlock}
  //   //        </div>`
  //   //   };

  //   //   this.jobService.updateJob(this.jobId, updatedJob).subscribe(() => {
  //   //     alert('Saved');
  //   //   });
  //   // });
  // }



submitForm() {
  const formData = this.form.value;
  const htmlBlock = this.generateHTML(formData);

  const newMarker = `form-entry-${new Date().toISOString()}`;
  const htmlToAppend = `
    <div class="form-entry" data-marker="${newMarker}">
      ${htmlBlock}
    </div>
  `;

  // Merge data into job model
  const updatedJob = {
    ...this.job,
    client_additional_create_data: JSON.stringify(formData),
    client_additional_create_data_HTML: htmlToAppend,
  //  special_instructions_HTML: (this.job?.special_instructions_HTML || '') + htmlToAppend // Only do this when submitting the job....
  };

  // Save back to database
  this._demoService.updateJobAll(updatedJob).subscribe({
    next: () => {
      this.toastr.success('Form saved and instructions updated.');
      this.showPreview = false;
      // redirect entire page on save. client.
      this.gfunc.globalJobEditStep3SkipRoute(this.job.job_id);

    },
    error: err => {
      this.toastr.error('Failed to save form.');
      console.error(err);
    }
  });
}




// generateHTML(data: any): string {
//   let html = `<div><h4>Dynamic Form Submission</h4>`;
//   html += this.renderDataAsHTML(data);
//   html += `</div>`;
//   return html;
// }

generateHTML(data: any): string {
  return `<div>${this.renderDataAsHTML(data, this.schema)}</div>`;
}


// renderDataAsHTML(data: any, depth: number = 0): string {
//   let html = '';

//   if (Array.isArray(data)) {
//     data.forEach((item, index) => {
//       html += `<div style="margin-left: ${depth * 20}px;"><strong>Item ${index + 1}</strong></div>`;
//       html += this.renderDataAsHTML(item, depth + 1);
//     });
//   } else if (typeof data === 'object' && data !== null) {
//     for (const key in data) {
//       if (!data.hasOwnProperty(key)) continue;

//       const value = data[key];

//       if (typeof value === 'object') {
//         html += `<div style="margin-left: ${depth * 20}px;"><strong>${key}</strong>:</div>`;
//         html += this.renderDataAsHTML(value, depth + 1);
//       } else {
//         html += `<div style="margin-left: ${depth * 20}px;"><strong>${key}</strong>: ${value}</div>`;
//       }
//     }
//   } else {
//     html += `<div style="margin-left: ${depth * 20}px;">${data}</div>`;
//   }

//   return html;
// }


// renderDataAsHTML(data: any, schema: any[] = this.schema, depth: number = 0): string {
//   if (!schema) return '';

//   // let html = '<table class="table table-bordered" style="margin-bottom: 10px;">';
//   let html = '<table class="  table table-sm table-borderless mb-1" style="margin-bottom: 10px;">';



//   schema.forEach(field => {
//     const value = data[field.key];

//     if (field.type === 'group') {
//       if (field.repeatable && Array.isArray(value)) {
//         value.forEach((item, index) => {
//           html += `<tr><td colspan="2"><strong>${field.label} #${index + 1}</strong></td></tr>`;
//           html += `<tr><td colspan="2">${this.renderDataAsHTML(item, field.fields, depth + 1)}</td></tr>`;
//         });
//       } else if (value) {
//         html += `<tr><td colspan="2"><strong>${field.label}</strong></td></tr>`;
//         html += `<tr><td colspan="2">${this.renderDataAsHTML(value, field.fields, depth + 1)}</td></tr>`;
//       }
//     } else {
//       const label = field.label || field.key;
//       const displayValue = value ? value : '<em>Not specified</em>';
//       html += `<tr>
//         <td style="width: 30%;"><strong>${label}</strong></td>
//         <td>${displayValue}</td>
//       </tr>`;
//     }
//   });

//   html += '</table>';
//   return html;
// }

// renderDataAsHTML(data: any, schema: any[] = this.schema, depth: number = 0): string {
//   let html = '<div class="preview-container">';

//   let currentRowCols = 0;
//   let rowBuffer: string[] = [];

//   for (const field of schema) {
//     const colClass = field.col || 12;
//     const label = field.label || field.key;
//     const value = this.formatValue(data[field.key]);

//     const fieldHtml = `
//       <div class="preview-field col-sm-${colClass}">
//         <strong>${label}:</strong> ${value}
//       </div>
//     `;

//     currentRowCols += colClass;
//     rowBuffer.push(fieldHtml);

//     if (currentRowCols >= 12) {
//       html += `<div class="row">${rowBuffer.join('')}</div>`;
//       currentRowCols = 0;
//       rowBuffer = [];
//     }
//   }

//   // Final row
//   if (rowBuffer.length > 0) {
//     html += `<div class="row">${rowBuffer.join('')}</div>`;
//   }

//   html += '</div>';
//   return html;
// }


renderDataAsHTML(data: any, schema: any[] = this.schema): string {
  return this.renderSchemaWithData(schema, data);
}


// renderSchemaWithData(schema: any[], data: any): string {
//   // style="width:100%; border-collapse: collapse;"
//   let html = `<table class="table table-responsive" >`;

//   let currentRowCols = 0;
//   let rowFields: any[] = [];

//   // for (let field of schema) {
//   //   const col = this.extractColWidth(field.col);
//   //   const labelCol = this.extractColWidth(field.labelCol);
//   //   const totalCol = col + labelCol;

//   //   if (currentRowCols + totalCol > 12) {
//   //     html += this.renderRow(rowFields, data);
//   //     rowFields = [];
//   //     currentRowCols = 0;
//   //   }

//   //   rowFields.push({ ...field, _colTotal: totalCol });
//   //   currentRowCols += totalCol;
//   // }

//         for (let field of schema) {
//           const isGroup = field.type === 'group';
//           const label = field.label || field.key;
//           const value = data?.[field.key];

//           // Handle groups separately
//           if (isGroup) {
//             html += `
//               <tr>
//                 <td colspan="12" style="padding-top: 20px;">
//                 <!--  <strong>${label}</strong> -->
//                 </td>
//               </tr>
//             `;

//             if (field.repeatable && Array.isArray(value)) {
//               value.forEach((item, index) => {
//                 html += `
//                   <tr>
//                     <td colspan="12" style="padding-left: 20px;">
//                       <strong>${label} #${index + 1}</strong>
//                       ${this.renderSchemaWithData(field.fields, item)}
//                     </td>
//                   </tr>
//                 `;
//               });
//             } else if (value && typeof value === 'object') {
//               html += `
//                 <tr>
//                   <td colspan="12" style="padding-left: 20px;">
//                     ${this.renderSchemaWithData(field.fields, value)}
//                   </td>
//                 </tr>
//               `;
//             }

//             continue; // skip normal field rendering
//           }

//           // Non-group field processing
//           const col = this.extractColWidth(field.col);
//           const labelCol = this.extractColWidth(field.labelCol);
//           const totalCol = col + labelCol;

//           if (currentRowCols + totalCol > 12) {
//             html += this.renderRow(rowFields, data);
//             rowFields = [];
//             currentRowCols = 0;
//           }

//           rowFields.push({ ...field, _colTotal: totalCol });
//           currentRowCols += totalCol;
//         }



//   if (rowFields.length) {
//     html += this.renderRow(rowFields, data);
//   }

//   html += `</table>`;
//   return html;
// }


// renderRow(fields: any[], data: any): string {
//   let row = '<tr>';

//   for (const field of fields) {
//     const colSpan = this.extractColWidth(field.col) + this.extractColWidth(field.labelCol);
//     const label = field.label || field.key;
//     const value = data?.[field.key];
//     const displayValue = this.formatValue(value);

//     row += `
//       <td colspan="${colSpan}" style="padding: 4px; vertical-align: top;">
//         <div><small style="font-weight: bold;">${label}:</small> ${displayValue}</div>
//       </td>
//     `;
//   }

//   row += '</tr>';
//   return row;
// }


renderSchemaWithData(schema: any[], data: any, depth: number = 0): string {
  let html = `<table class="table table-responsive">`;

  let currentRowCols = 0;
  let rowFields: any[] = [];

  const flushRow = () => {
    if (rowFields.length > 0) {
      html += this.renderRow(rowFields, data, depth);
      rowFields = [];
      currentRowCols = 0;
    }
  };

  for (const field of schema) {
    const value = data?.[field.key];
    const totalColSpan = this.extractColWidth(field.labelCol) + this.extractColWidth(field.col);

    if (field.type === 'group') {
      flushRow(); // Finish previous row first
      if (field.repeatable && Array.isArray(value)) {
        value.forEach((item, index) => {
          html += `
            <tr><td colspan="12" style="padding-left:${depth * 20}px;">
              <strong>${field.label} #${index + 1}</strong>
              ${this.renderSchemaWithData(field.fields, item, depth + 1)}
            </td></tr>
          `;
        });
      } else if (value) {
        html += `
          <tr><td colspan="12" style="padding-left:${depth * 20}px;">
            <strong>${field.label}</strong>
            ${this.renderSchemaWithData(field.fields, value, depth + 1)}
          </td></tr>
        `;
      }
    } else {
      // If adding this field would overflow, flush
      if (currentRowCols + totalColSpan > 12) {
        flushRow();
      }

      rowFields.push({ ...field, totalColSpan });
      currentRowCols += totalColSpan;
    }
  }

  flushRow(); // Flush last row
  html += `</table>`;
  return html;
}

renderRow(fields: any[], data: any, depth: number = 0): string {
  let row = '<tr>';

  for (const field of fields) {
    const label = field.label || field.key;
    const value = data?.[field.key];
    const displayValue = this.formatValue(value);
    const colspan = field.totalColSpan || 12;

    row += `
      <td colspan="${colspan}" style="padding: 4px; padding-left:${depth * 20}px; vertical-align: top;">
        <div><small>${label}:</small> ${displayValue}</div>
      </td>
    `;
  }

  row += '</tr>';
  return row;
}



formatValue(value: any, field?: any): string {
  if (value == null || value === '') return '-';

  // Handle array (repeatable group or simple array)
  if (Array.isArray(value)) {
    if (field?.type === 'group' && field?.repeatable && field?.fields) {
      return value
        .map((item, i) => `
          <div><strong>${field.label} #${i + 1}</strong></div>
          ${this.renderSchemaWithData(field.fields, item)}
        `)
        .join('');
    } else {
      // basic array like [1, 2, 3]
      return value.map(v => this.formatValue(v)).join(', ');
    }
  }

  // Handle object (nested group)
  if (typeof value === 'object') {
    if (field?.type === 'group' && field?.fields) {
      return this.renderSchemaWithData(field.fields, value);
    }

    // fallback for unexpected object shape
    return this.renderSchemaWithData(
      Object.keys(value).map(k => ({
        key: k,
        label: this.humanizeLabel(k),
        col: 'col-sm-12',
        type: 'text'
      })),
      value
    );
  }

  return value.toString();
}


extractColWidth(colClass: string): number {
  if (!colClass || typeof colClass !== 'string') return 0;

  const match = colClass.match(/col-(?:xs|sm|md|lg|xl)-(\d{1,2})/);
  return match ? parseInt(match[1], 10) : 0;
}


humanizeLabel(label: string): string {
  return label
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}


// Functions
getJob(job_id) {

         // this.getSystemLogTypeDataSector(24) // hard coded into the data sector system.


 this._demoService.getJobID(job_id).subscribe(
    data => {  
      this.job = data[0]; // NOT the full array
     let res = data[0];
     // must pass as I stringify on save above
const savedData = this.job?.client_additional_create_data
  ? JSON.parse(this.job.client_additional_create_data)
  : {};
      if (this.schema) {
        this.form = this.buildForm(this.schema, savedData);
      }

   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


resetForm() {
  this.form = this.buildForm(this.schema);
  this.previewHTML = '';
  this.showPreview = false;
}


getSystemLogTypeDataSector(log_type_data_sector_id) {
  this._demoService.getSystemLogTypeDataSector(log_type_data_sector_id)
    .subscribe(
      res => {
        this.system_log_type_data_sector = res;
        const data = res[0];

        try {
          this.schema = typeof data.condition_array_keys_example === 'string'
            ? JSON.parse(data.condition_array_keys_example)
            : data.condition_array_keys_example;

          const savedData = data.form_data || {};
          this.form = this.buildForm(this.schema, savedData);

        } catch (err) {
          console.error('Failed to parse schema JSON:', err);
          this.schema = [];
        }
      },
      err => console.error(err.status)
    );
}




generatePreview() {
  const formData = this.form.value;
  this.previewHTML = this.generateHTML(formData);
  this.showPreview = true;
}



  // update was here for onit but moved for onchange
  updateJobAll(model) {
  
model.updated_date = this.gfunc.todayDate
model.updated_by = this.gfunc.sessionUserId

//     // New Special Instructions formatting (Save Old into New Ready to Go Live.)
// if(model.special_instructions_HTML == null){model.special_instructions_HTML = model.special_instructions}

    this._demoService.updateJobAll(model).subscribe(
       data => { 
       this.toastr.success('Job Updated');
              //  // Subject to reload the manager component parent.
              // // TraceCandidateManagerComponent.returned.next(false); // refreshed below component?
              // this.gfunc.insertLog_UpdateJob(model);
              // this.gfunc.globalJobView(model.job_id);
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error updating your Job!');
        return console.log(error);
       }
  );
  }




// sends to step three form field when saving.
getDynamicFormOutput(): { data: any, html: string } {
  const data =  this.form?.value || {};
  const html = this.generateHTML(data);
this.toastr.info('getting dynaimc form data')

  return { data, html };
}






getSystemLogTypeDataSectorAndThenLoadJob(job_id: number) {
  this._demoService.getSystemLogTypeDataSector(24).subscribe(
    res => {
      const data = res[0];

      try {
        this.schema = typeof data.condition_array_keys_example === 'string'
          ? JSON.parse(data.condition_array_keys_example)
          : data.condition_array_keys_example;

        // ✅ Now that schema is ready, load job
        this.loadJobAndBuildForm(job_id);

      } catch (err) {
        console.error('Failed to parse schema JSON:', err);
        this.schema = [];
      }
    },
    err => console.error(err)
  );
}

loadJobAndBuildForm(job_id: number) {
  this._demoService.getJobID(job_id).subscribe(
    data => {
      this.job = data[0];
      const savedData = this.job?.client_additional_create_data
        ? JSON.parse(this.job.client_additional_create_data)
        : {};

      // ✅ Build form with loaded schema
      this.form = this.buildForm(this.schema, savedData);
    },
    err => console.error(err)
  );
}



}